import * as Factory from 'factory.ts'
import faker from 'faker'

import {
  type APCreditCard,
  type SimpleAPCreditCard,
} from '@webapp/models/APCreditCard'
import { APCreditCardTypes } from '@webapp/models/enums'
import { CurrencyMock } from './currency.factory'
import { SimpleUserMock } from './user.factory'

export const APCreditCardMock = Factory.Sync.makeFactory<APCreditCard>({
  id: Factory.each(() => faker.random.number()),
  assignees: SimpleUserMock.buildList(1),
  balance: null,
  currency: CurrencyMock.build({ name: 'CAD' }),
  gl_code: '',
  last_reconciliation_balance: 0,
  last_reconciliation_date: Factory.each(() => faker.date.past().toISOString()),
  last_statement_date: Factory.each(() => faker.date.past().toISOString()),
  name: Factory.each(
    () =>
      `${faker.random.word()} ${(faker.random.number(9999) * 1000)
        .toString()
        .substr(0, 4)}`
  ),
  number: Factory.each(() =>
    (faker.random.number(9999) * 1000).toString().substr(0, 4)
  ),
  session: null,
  type: APCreditCardTypes.VISA,
  vendor: null,
})

export const SimpleAPCreditCardMock =
  Factory.Sync.makeFactory<SimpleAPCreditCard>({
    id: Factory.each(() => faker.random.number()),
    currency: CurrencyMock.build({ name: 'CAD' }),
    name: Factory.each(
      () =>
        `${faker.random.word()} ${(faker.random.number(9999) * 1000)
          .toString()
          .substr(0, 4)}`
    ),
    number: Factory.each(() =>
      (faker.random.number(9999) * 1000).toString().substr(0, 4)
    ),
    type: APCreditCardTypes.VISA,
    vendor: null,
  })
